const searchParamsConstant = {
  promotionID: 'promotionID',
  ecwidPayload: 'payload',
};

export default searchParamsConstant;
